// React
import React from 'react';
import {useState} from 'react';

// MUI
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import {AdvancedSection} from './AdvancedSection';

export default function FanProperties(props) {
    const [, setValue] = useState(props.node.fb.runFor);
    const [, setDelayedStart] = useState(props.node.fb.delayedStart);
    const dailyDriven = !!props.dailyDriven;
    const dailyOnlyDriven = !!props.dailyOnlyDriven;

    function handleChange(e) {
        props.node.fb.runFor = e.target.valueAsNumber;
        setValue(e.target.value);
        props.changeFunc(props.node);
    }
    function handleDelayedStartChange(e) {
        props.node.fb.delayedStart = e.target.valueAsNumber;
        setDelayedStart(e.target.value);
        props.changeFunc(props.node);
    }
    const watchdogTooltip = "Driven by a Daily schedule as the sole source: this becomes a fixed timeout";
    const conflictTooltip = "Driven by a Daily schedule AND other sources. Pick a compromise or remove one of the conflicting edges.";
    return (
        <Box sx={{display:'flex', flexDirection:'column', padding:2}}>
            <Tooltip
                title={dailyOnlyDriven ? watchdogTooltip : (dailyDriven ? conflictTooltip : "")}
                placement="top"
                disableHoverListener={!dailyDriven}
            >
                <TextField
                    label="Run for"
                    value={props.node.fb.runFor}
                    helperText={dailyOnlyDriven
                        ? "run timeout (s) — locked by Daily schedule"
                        : (dailyDriven
                            ? "warning: Daily + other sources conflict"
                            : "seconds")}
                    type="number"
                    disabled={dailyOnlyDriven}
                    onChange={handleChange}
                />
            </Tooltip>
            {dailyOnlyDriven &&
                <Typography variant="caption" sx={{mt:1, color:'text.secondary'}}>
                    This relay is driven by a Daily schedule, so Run for is a watchdog timeout. Remove the Daily edge to edit.
                </Typography>
            }
            {dailyDriven && !dailyOnlyDriven &&
                <Typography variant="caption" sx={{mt:1, color:'warning.main'}}>
                    Daily expects short runFor (~3s) as a watchdog; other sources may want longer. No single value satisfies both.
                </Typography>
            }
            <AdvancedSection>
                <TextField label="Delayed start" value={props.node.fb.delayedStart} helperText="seconds" type="number" onChange={handleDelayedStartChange}/>
            </AdvancedSection>
        </Box>
    )
}

export {FanProperties};
// time in seconds
export const FanPropertiesExtension = {runFor:300, delayedStart:0};
